import { Box, Flex, Text } from '~/design-system';
import { Trans } from '@lingui/macro';
import Button from '../Button/Button';
import { Modal } from '~/design-system';

export default function Confirmation({ message, onCancel, onConfirm }) {
  return (
    <Modal
      onClose={onCancel}
      aria-label="Confirm Deletion"
      //@ts-ignore - sx not in IntrinsicAttributes
      sx={{
        backgroundColor: 'White',
        maxWidth: '500px',
        minHeight: 'initial',
        marginX: 'auto',
      }}
    >
      <Text sx={{ paddingTop: 4, marginX: 4 }}>{message}</Text>

      <Flex
        sx={{ borderTop: '1px solid #e5e5e5;', marginTop: 4, paddingBottom: 3 }}
      >
        <Box sx={{ marginLeft: 'auto', paddingRight: 3, marginTop: 3 }}>
          <Button onClick={onCancel} sx={{ marginRight: 2, cursor: 'pointer' }}>
            {/* @ts-ignore */}
            <Trans>Cancel</Trans>
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            sx={{ cursor: 'pointer' }}
          >
            {/* @ts-ignore */}
            <Trans>Yes</Trans>
          </Button>
        </Box>
      </Flex>
    </Modal>
  );
}
